/**
 * FII FIT – Application mode configuration.
 *
 * Aplicația a fost transformată dintr-o platformă medicală într-o
 * aplicație de fitness (FII FIT). Tot codul moștenit care ținea de modul
 * "CHRONIC" (boli cronice, terapie, prescripții, specialiști, dosar medical,
 * etc.) este ascuns prin acest flag global, fără a fi șters din baza de cod
 * (pentru a putea fi reactivat ușor dacă se decide vreodată reluarea
 * funcționalității medicale).
 *
 * Reguli:
 *   - APP_MODE = 'FITNESS'  → arătăm doar fluxul HEALTHY/fitness.
 *   - APP_MODE = 'FULL'     → comportament complet (legacy / dezvoltare).
 *
 * NU pune logica de business în fișierele consumer; folosește helper-ele
 * exportate aici (isChronicEnabled / forcedLifestyleMode) astfel încât
 * schimbarea modului să se facă într-un singur loc.
 */

export type AppMode = 'FITNESS' | 'FULL';
export type LifestyleMode = 'HEALTHY' | 'CHRONIC';

/** Mod curent al aplicației – FII FIT rulează în modul "FITNESS". */
export const APP_MODE: AppMode = 'FITNESS';

/** Dacă funcționalitățile CHRONIC sunt vizibile (rute, meniuri, secțiuni). */
export const isChronicEnabled = (): boolean => APP_MODE !== 'FITNESS';

/** Dacă funcționalitățile HEALTHY/fitness sunt active (mereu true). */
export const isHealthyEnabled = (): boolean => true;

/**
 * Lifestyle mode forțat. În FITNESS toți utilizatorii sunt considerați
 * HEALTHY indiferent ce ar avea salvat în baza de date (din modul CHRONIC legacy).
 */
export const forcedLifestyleMode = (): LifestyleMode | null =>
  APP_MODE === 'FITNESS' ? 'HEALTHY' : null;

/**
 * Returnează lifestyle mode-ul efectiv pentru un user, aplicând forțarea
 * de mai sus. Folosește asta peste tot unde citești user.lifestyleMode.
 */
export const getEffectiveLifestyleMode = (
  rawMode?: string | null
): LifestyleMode => {
  const forced = forcedLifestyleMode();
  if (forced) return forced;
  return (rawMode as LifestyleMode) || 'HEALTHY';
};

/** Etichete UI pentru meniuri – ușor de tradus / brand-uit. */
export const APP_LABELS = {
  name: 'FII FIT',
  tagline: 'Aplicația ta de fitness personalizată',
  domain: 'fiifit.ro',
};
